import { render } from "./PrefixPortal.vue?vue&type=template&id=12f54481&scoped=true"
import script from "./PrefixPortal.vue?vue&type=script&lang=js"
export * from "./PrefixPortal.vue?vue&type=script&lang=js"

import "./PrefixPortal.vue?vue&type=style&index=0&id=12f54481&scoped=true&lang=css"

import exportComponent from "C:\\Sveve\\www\\vue\\sveve.no\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12f54481"]])

export default __exports__